import { Component } from '@angular/core';

@Component({
  selector: 'app-invoice-layout',
  standalone: false,
  templateUrl: './invoice-layout.component.html',
  styleUrl: './invoice-layout.component.scss'
})
export class InvoiceLayoutComponent {

}
